import React from "react";
import { NumberInput } from "react-admin";
import PlayerStats from "./PlayerStats";

const BasketballPlayerStats = ({ s }) => {
  return (
    <PlayerStats s={s}>
      <NumberInput label="Total Points" source={s("totalPoints")} />
    </PlayerStats>
  );
};

export default BasketballPlayerStats;
